<template>
    <div>
        <div style="position: relative">
            <img
                v-if="image"
                :src="image"
                class="image"
            />
        </div>
    </div>
</template>

<script>

import Core from "@/modules/core/service/Core";
import Img from "@/modules/img/components/service/Img";

export default {
    name: "CInspectionImage",

    props: {
        inspectionId: {

        },

        imageId: {

        }
    },

    data: () => ({
        image: null
    }),

    mounted () {
        this.load();
    },

    watch: {
        inspectionId () {
            this.load();
        },

        imageId () {
            this.load();
        },
    },

    methods: {
        load () {
            if (!this.inspectionId || !this.imageId) {
                return;
            }

            // Media service: display size, else the original (PDF, image without variants).
            const [url, ...fallbacks] = Img.imageUrlsById(this.imageId);
            this.fetchFirst(url, fallbacks);
        },

        fetchFirst (url, fallbacks) {
            fetch(url, {method: "GET", headers: Core.method.jsonHeader()})
                .then(response => {
                    if (!response.ok) {
                        if (response.status === 404 && fallbacks.length > 0) {
                            this.fetchFirst(fallbacks[0], fallbacks.slice(1));
                        }
                        return;
                    }
                    return response.blob().then(blob => {
                        const data = new Blob([blob], {type: response.headers.get("Content-Type")});
                        this.image = URL.createObjectURL(data);
                    })
                });
        }
    }
}
</script>

<style scoped>

.image {
    object-fit: cover;
    width: 100%;
    margin-left: 8px;
    height: 100%;
    aspect-ratio: 1.0;
    border-radius: 4px
}

.image-title {
    height: 30px;
    font-size: 16px;
    position: absolute;
    top: 15px;
    right: calc(50% - 100px);
    z-index: 5;
    width: 200px;
    border-radius: 4px;
    text-align: center;
    padding-top: 4px;
    font-weight: 400;
}

</style>